import $ from 'jquery';
import 'bootstrap';

export const init = () => {
  let courseList = $('div[data-my-id="courseList"]');
  $('#mall_list_page_select').change(() => {
    let idx = $('#mall_list_page_select').val();
    courseList.hide();
    courseList.eq(idx - 1).show();
  });
};
